import { Route, Routes } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import {
  BeketCalendarPage,
  BeketMainPage,
  BeketMyOrdersPage,
  BeketOrderPage,
  BeketSearchDirection,
  BeketSearchFormPage,
  BeketTripDetails,
  CheckDataBeket,
  SchemeOrder,
  SearchResultBeket,
  SearchResultBeletPageWidget,
} from 'pages/beket/routes/index.ts'

export const BeketPages = () => {
  return (
    <Routes>
      <Route
        path={RoutingPaths.beket.start()}
        element={<BeketMainPage />}
      />

      <Route
        path={RoutingPaths.beket.searchDirection.base()}
        element={<BeketSearchDirection />}
      />

      <Route
        path={RoutingPaths.beket.calendar.base()}
        element={<BeketCalendarPage />}
      />

      <Route
        path={RoutingPaths.beket.order.base()}
        element={<BeketOrderPage />}
      />

      <Route
        path={RoutingPaths.beket.myTickets.detail.base()}
        element={<BeketMyOrdersPage />}
      />

      <Route
        path={RoutingPaths.beket.tripDetails.base()}
        element={<BeketTripDetails />}
      />

      <Route
        path={RoutingPaths.beket.check.base()}
        element={<CheckDataBeket />}
      />

      <Route
        path={RoutingPaths.beket.schemeOrder.base()}
        element={<SchemeOrder />}
      />

      <Route
        path={RoutingPaths.beket.searchResults.base()}
        element={<SearchResultBeket />}
      />

      <Route
        path={RoutingPaths.beket.searchResultsWidget.base()}
        element={<SearchResultBeletPageWidget />}
      />

      <Route
        path={RoutingPaths.beket.searchForm.base()}
        element={<BeketSearchFormPage />}
      />
    </Routes>
  )
}
